module.exports = __webpack_public_path__ + "img/step4-04.c3ce4975.jpg";